import { FC, useEffect } from 'react'
import { authStore } from '../store/auth'
import { relayStore } from '../store/relay'

const Logout: FC = () => {
	const { logout } = authStore()
	const { clearAll } = relayStore()

	useEffect(() => {
		const timer = setTimeout(() => {
			logout()
			clearAll()
		}, 500)

		return () => {
			clearTimeout(timer)
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<h1>
			<center>До свидания!</center>
		</h1>
	)
}

export default Logout
